module.exports = __webpack_public_path__ + "img/moon.6f8d41d6.svg";